module.exports = __webpack_public_path__ + "static/development-c4aec12359289522b1017b88a4c0ebeb.webp";